import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class ConfiguracionesService {
  public static readonly INDICE_INPC_KEY: string = 'indice_inpc';
  
  private service_url: string;
  private serviceFotosUrl: string;

  constructor(private http: Http, 
    private constantsService: ConstantsService, 
    private validatorService: ValidatorService,
    private authService: AutenticacionService, 
    private errorService:ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/configuraciones';
  }

  public validar(configuracion: any){
    let error = [];

    //Validar configuración indice_inpc
    if(configuracion.key == ConfiguracionesService.INDICE_INPC_KEY){
      
      if(!this.validatorService.required(configuracion.value)){
        error["indice_inpc"] = this.errorService.required;
      }else if(!this.validatorService.numeric(configuracion.value)){
        error["indice_inpc"] = this.errorService.numeric;
      }

    }

   

    return error;
  }

  public listarConfiguraciones() {

    const options = this.authService.getAuthHeaders();

    return this.http.get(this.service_url, options);
  }

  public actualizar(configuracion : any) {
    return this.http.put(this.service_url , configuracion, this.authService.getAuthHeaders());
  }

}


// WEBPACK FOOTER //
// ./src/app/services/configuraciones.service.ts